module.exports = {"id":"216447","name":"Álvaro García","rating":"76","photo":"./data/images/photos/0/216447.png","club":{"name":"Cádiz C.F.","logo":"./data/images/clubs/CadizC.F..png"},"positions":["MG","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlvaroGarcia0.json
// module id = 306
// module chunks = 0